import { useTranslation } from "react-i18next";
import { Divider, Form, Icon } from "semantic-ui-react";

import { useSelectedDealer, useSelectedLocation } from "components";
import { Element } from "components/ReactScroll/index";
import { createFormHelper } from "lib/Form";
import { DMSIDS } from "models";
import { useEstablishmentIdsQuery } from "modules/LocationOverviewDashboard/hooks";

import type { LocationDetailFormPayload } from "modules/LocationOverviewDashboard/hooks";

const FormHelper = createFormHelper<LocationDetailFormPayload>();

type ServiceProps = {
  tabId: string;
};

export const Service = ({ tabId }: ServiceProps) => {
  const { t } = useTranslation();

  const { selectedLocation } = useSelectedLocation();
  const { selectedDealer } = useSelectedDealer();

  const { data: establishmentIdsOptions = [] } = useEstablishmentIdsQuery();

  return (
    <Element name={tabId} className="location-overview-section">
      <div className="section-title">
        <div>
          <Icon className="wrench" />
        </div>
        <span className="section-title-text">{t("v8_service", "Service")}</span>
      </div>

      {selectedDealer?.planit_planning_enabled && (
        <>
          <div className="location-overview-subheading">{t("v8_planit_planning_configuration", "PlanIT planning configuration")}</div>
          <Form.Group>
            <Form.Field width={16}>
              <FormHelper.Field.Checkbox name="planit_planning_replacement_vehicle" label={t("v8_show_replacement_car", "Show replacement car")} />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field width={8}>
              <label>{t("v8_establishment_id", "Establishment ID")}</label>
              <FormHelper.Field.Dropdown name="planit_planning_establishment_id" options={establishmentIdsOptions} />
            </Form.Field>
          </Form.Group>
          <Divider />
        </>
      )}

      {selectedLocation?.dms_id === DMSIDS.TRUCK_VISION && (
        <>
          <div className="location-overview-subheading">{t("v8_truck_vision_web_clock_configuration", "TruckVision WebClock configuration")}</div>
          <Form.Group>
            <Form.Field width={16}>
              <label>Omgeving ID</label>
              <FormHelper.Field.Input name="web_clock_omgeving_id" />
            </Form.Field>
          </Form.Group>
          <Divider />
        </>
      )}

      <div className="location-overview-subheading">{t("v8_xentry_configuration", "Xentry configuration")}</div>
      <Form.Group>
        <Form.Field width={8}>
          <label>{t("v8_xentry_sub_outlet_id", "Xentry sub outlet ID")}</label>
          <FormHelper.Field.Input name="xentry_sub_outlet_id" />
        </Form.Field>
      </Form.Group>
    </Element>
  );
};
